export default {
    title: 'VERI*FACTU',
    whatIs: {
        title: '¿Qué es VERI*FACTU?',
        p1: 'VERI*FACTU no es un software en sí, sino un conjunto de requisitos técnicos y legales que deben cumplir los Sistemas Informáticos de Facturación (SIF) en España.',
        p2: 'Su objetivo: garantizar la transparencia, trazabilidad e integridad de las facturas — impedir manipulaciones, contabilidades paralelas («caja B»), borrados o alteraciones de registros.'
    },
    whoIsAffected: {
        title: '¿Quiénes están afectados?',
        p1: 'Afecta a empresas, profesionales y autónomos que usen sistemas informáticos o electrónicos para emitir facturas.',
        p2: 'Si una persona emite facturas de forma manual — por ejemplo con un simple documento impreso o plantilla sin funcionalidades contables — no estaría obligada a cumplir VERI*FACTU.'
    },
    requirements: {
        title: 'Principales requisitos de los sistemas de facturación con VERI*FACTU',
        intro: 'Cuando usas un SIF, este debe cumplir con varios criterios técnicos y de seguridad:',
        li1: 'Registro automático y único por cada factura emitida (incluyendo nuevas facturas, anulaciones o rectificaciones).',
        li2: 'Inalterabilidad de los registros: las facturas no pueden modificarse o borrarse sin dejar constancia; se usan firmas electrónicas, hashes encadenados u otros mecanismos seguros.',
        li3: 'Trazabilidad y conservación: los registros deben mantenerse de forma accesible, legible y conservados en condiciones que permitan su consulta si la autoridad lo exige.',
        li4: 'Identificación “Veri*Factu” en la factura: cuando se use este sistema, la factura debe advertir que se ha generado bajo VERI*FACTU y, usualmente, incluir un código QR con datos identificativos.',
        li5: 'Posibilidad de envío a la Agencia Tributaria (AEAT): los sistemas deben permitir, si se desea, enviar los registros de facturación a AEAT, preferiblemente en tiempo real o inmediatamente antes de emitir la factura.'
    },
    optionVerifactu: {
        title: 'Opción Verifactu',
        p1: 'Antes de elegir la opción Verifactu, el usuario debe saber que esta opción debe mantenerse durante el año actual, es decir, no se podrá cambiar a otra opción hasta el 1 de enero del siguiente año.',
        p2: 'Con la opción Verifactu, una vez enviadas las facturas, se generarán de forma automática los ficheros XML y se enviarán a la AEAT, cómo es requerido.',
        p3: 'La información de este proceso puede verse en la pestaña Enviadas, dentro del menú superior "Verifactu". Bajo esta opción, podrá verse qué facturas se han enviado y también habrá la posibilidad de descargar el fichero XML en bruto enviado a Verifactu',
        p4: 'También se podrá ver el código QR generado en el PDF de la factura, al inicio del mismo.'
    },
    optionNoVerifactu: {
        title: 'Opción No Verifactu',
        p1: 'Si se elige la opción No Verifactu, la plataforma generará de forma automática los ficheros XML por cada factura enviada, pero dichos ficheros se mantendrán guardados internamente, sin ser enviados a la AEAT, hasta que ésta los solicite mediante un requerimiento al usuario.',
        p2: 'Requerimiento: buscar facturas para el requerimiento exigido por la AEAT por fecha de emisión. Se necesita conocer el número de requerimiento enviado por la AEAT.',
        p3: 'Enviadas: muestra un listado con información de las facturas sobre las que se ha realizado envío de fichero a Verifactu (voluntario y bajo requerimiento).',
        p4: 'Comprobar huella: permite comprobar la huella de los registros de facturación y eventos generados.',
        p5: 'Exportar registros: exporta en formato ZIP los registros de facturación y eventos.'
    },
    deadlines: {
        title: 'Plazos de implementación',
        p1: 'La obligación efectiva de usar software compatible recae sobre las empresas — especialmente sociedades — desde el 1 de enero de 2027. Para autónomos y profesionales, el plazo se extiende hasta julio de 2027.',
        p2: "Si bien el uso de “modo VERI*FACTU” no es obligatorio para todos — puede optarse por conservar registros internamente — opción 'No Verifactu', el software debe cumplir los requisitos del reglamento."
    },
    why: {
        title: '¿Por qué se impulsa VERI*FACTU?',
        intro: 'Los objetivos principales son:',
        li1: 'Combatir el fraude fiscal reduciendo el uso de contabilidades paralelas.',
        li2: 'Asegurar la transparencia, integridad y fiabilidad de la facturación en España.',
        li3: 'Acompañar la digitalización de la gestión de facturas y adaptarse a los nuevos tiempos, con sistemas seguros, estructurados y verificables.'
    },
    documentation: {
        title: 'Documentación oficial',
        link1Text: 'Real Decreto 254/2025',
        link1Suffix: ', de 1 de abril, por el que se modifica el Real Decreto 1007/2023, de 5 de diciembre, por el que se aprueba el Reglamento que establece los requisitos que deben adoptar los sistemas y programas informáticos o electrónicos que soporten los procesos de facturación de empresarios y profesionales, y la estandarización de formatos de los registros de facturación.',
        link2Text: 'Preguntas frecuentes que se hacen las empresas, pymes y autónomos.'
    },
    requerimiento: {
        title: 'Verifactu - Envío por requerimiento',
        numeroRequerimiento: {
            label: 'Número de requerimiento',
            helper: 'Máx. 18 caracteres'
        },
        filter: {
            title: 'Búsqueda de facturas',
            period: 'Periodo de búsqueda',
            from: 'Desde',
            to: 'Hasta'
        },
        modal: {
            title: 'Número de requerimiento'
        },
        table: {
            serieFactura: 'Serie',
            numeroFactura: 'Nº factura',
            fechaExpedicionFactura: 'Fecha de expedición',
            razonSocialEmisor: 'Proveedor',
            razonSocialDestinatario: 'Destinatario',
            importeTotal: 'Importe'
        },
        button: {
            send: 'Enviar seleccionadas',
            back: 'Volver'
        },
        empty: 'No hay facturas pendientes de requerimiento',
        notRegisteredModality: 'No está registrado en la modalidad VeriFactu de requerimiento. Esta sección está disponible únicamente para usuarios con dicha modalidad.',
        result: {
            title: 'Resultado del envío',
            numeroRequerimiento: 'Número de requerimiento',
            nRegistros: 'Nº registros',
            finRequerimiento: 'Fin de requerimiento',
            pendientes: 'Pendientes',
            error: 'Error',
            estadoEnvio: 'Estado envío',
            csv: 'CSV',
            yes: 'Sí',
            no: 'No'
        }
    },
    enviadas: {
        title: 'Verifactu - Facturas remitidas',
        table: {
            idFactura: 'Id Factura',
            modalidad: 'Modalidad',
            fechaHoraEnvio: 'Fecha/hora de envío',
            download: 'Descargar'
        },
        modalidad: {
            voluntario: 'Voluntario',
            requerimiento: 'Requerimiento'
        },
        errors: {
            download: 'No se ha podido descargar el fichero de la factura'
        },
        empty: 'No hay facturas enviadas a VeriFactu'
    },
    comprobarHuella: {
        title: 'Comprobar huella',
        empty: 'No hay registros comprobables',
        tabs: {
            facturacion: 'Facturación',
            eventos: 'Eventos'
        },
        table: {
            idFactura: 'Id Factura',
            serie: 'Serie',
            numero: 'Nº',
            fechaExpedicion: 'Fecha expedición',
            importe: 'Importe',
            id: 'Id',
            tipoEvento: 'Tipo evento',
            fechaHora: 'Fecha/hora',
            comprobar: 'Comprobar'
        },
        eventTypes: {
            '01': 'Inicio de funcionamiento del SIF',
            '02': 'Fin de funcionamiento del SIF',
            '03': 'Lanzamiento de anomalías de facturación',
            '04': 'Detección de anomalías de facturación',
            '05': 'Lanzamiento de anomalías de eventos',
            '06': 'Detección de anomalías de eventos',
            '07': 'Restauración de copia de seguridad',
            '08': 'Exportación de registros de facturación',
            '09': 'Exportación de registros de eventos',
            '10': 'Resumen de eventos',
            '90': 'Otros eventos voluntarios'
        },
        resultado: {
            title: 'Resultado de la comprobación',
            campo: 'Campo',
            valor: 'Valor',
            valida: 'Huella válida',
            noValida: 'Huella NO válida',
            tipoRegistro: 'Tipo registro',
            tipoEvento: 'Tipo evento',
            idFactura: 'Id Factura',
            idEvento: 'Id Evento',
            serie: 'Serie',
            numero: 'Nº',
            fechaExpedicion: 'Fecha expedición',
            fechaHora: 'Fecha/hora',
            huellaCalculada: 'Huella calculada',
            huellaEsperada: 'Huella almacenada',
            cadenaReferencia: 'Cadena de referencia',
            anterior: 'Registro anterior',
            id: 'Id'
        },
        errors: {
            comprobar: 'No se ha podido comprobar la huella del registro'
        }
    },
    exportarRegistros: {
        title: 'Verifactu - Exportación de registros',
        nif: 'NIF',
        intro: 'Genera los ficheros ZIP con las facturas y los eventos registrados en el periodo seleccionado, aunque ya se hayan exportado anteriormente.',
        filter: {
            title: 'Búsqueda de registros',
            period: 'Periodo de exportación',
            from: 'Desde',
            to: 'Hasta'
        },
        button: 'Exportar registros',
        processing: 'Generando eventos...',
        result: {
            ok: 'Se han generado {count} fichero(s) para el NIF {nif}',
            ko: 'Error en la exportación para el NIF {nif}'
        },
        downloadFacturacion: 'Descargar facturación (ZIP)',
        downloadEventos: 'Descargar eventos (ZIP)'
    }
}
